module.exports = __webpack_public_path__ + "static/media/uparrow.4fda9a32.png";